<template>
  <div class="side-menu-wrap">
    <img v-if="theme === 'white'" class="side-menu-wrap__btn" src="@/assets/menuBtn-black.png" @click="toggleSideMenu()" />
    <img v-else class="side-menu-wrap__btn" src="@/assets/menuBtn.png" @click="toggleSideMenu()" />
    <span class="side-menu-wrap__title">Каталог продукции</span>
    <ul class="side-menu" :class="{'side-menu--white': theme === 'white'}" v-show="sideMenuVisibleProp">
      <li class="side-menu__item" @click="setFilter('all')" >Все</li>
      <li class="side-menu__item" @click="setFilter('stone')" >Щебень</li>
      <li class="side-menu__item" @click="setFilter('screening')" >Отсев</li>
      <li class="side-menu__item" @click="setFilter('sand')" >Песчанно-гравийная смесь</li>
    </ul>
  </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: "SideMenu",
  props: {
    sideMenuVisible: {
      type: Boolean,
      required: true,
      default: true,
    },
    theme: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      sideMenuVisibleProp: this.sideMenuVisible,
    };
  },
  computed: {},
  methods: {
    ...mapActions('products', [
      'setFilter'
    ]),
    toggleSideMenu() {
      this.sideMenuVisibleProp = !this.sideMenuVisibleProp;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.side-menu-wrap__btn {
  cursor: pointer;
}
.side-menu-wrap__title {
  padding-left: 10px;
}
.side-menu {
  padding-left: 0;
  margin-top: 10px;
}
.side-menu__item {
  list-style-type: none;
  padding: 10px 0 10px 20px;
  font-size: 1.6rem;
  transition: all 0.4s;
}
.side-menu__item:hover {
  background-color: $card-hover-color;
  letter-spacing: 1px;
  color: $light-gray-color;
}

.side-menu--white .side-menu__item:hover {
  background-color: $dark-white-color;
}
</style>
